module.exports = __webpack_public_path__ + "img/certificate.03218540.jpg";